import { useAuth } from '@/lib/auth'

export interface ItemTab {
  id: string
  label: string
  izin?: string[]
  jumlah?: number
}

export function Tabs({
  tab,
  aktif,
  onUbah,
  className = '',
}: {
  tab: ItemTab[]
  aktif: string
  onUbah: (id: string) => void
  className?: string
}) {
  const { izin } = useAuth()
  const tampil = tab.filter((t) => !t.izin || t.izin.length === 0 || t.izin.some((k) => izin.has(k)))

  return (
    <div className={`mb-4 flex flex-wrap gap-1 border-b border-netral-200 ${className}`} role="tablist">
      {tampil.map((t) => {
        const terpilih = t.id === aktif
        return (
          <button
            key={t.id}
            type="button"
            role="tab"
            aria-selected={terpilih}
            onClick={() => onUbah(t.id)}
            className={`-mb-px rounded-t-lg border-b-2 px-3 py-2 text-sm font-medium transition-colors ${
              terpilih
                ? 'border-yayasan-700 text-yayasan-800'
                : 'border-transparent text-netral-500 hover:border-netral-300 hover:text-netral-800'
            }`}
          >
            {t.label}
            {typeof t.jumlah === 'number' ? (
              <span className="ml-1.5 rounded-full bg-netral-100 px-1.5 py-0.5 text-xs text-netral-600">
                {t.jumlah}
              </span>
            ) : null}
          </button>
        )
      })}
    </div>
  )
}
